import { useEffect, useRef } from 'react'

import {
  BAR_COUNT,
  BAR_GAP,
  BAR_WIDTH,
  WAVEFORM_COLOR,
  drawFlatLine
} from '../components/SttQuickAction/waveform'

export const useSttWaveform = (
  isRecording: boolean,
  analyserNode: AnalyserNode | null | undefined,
  showCanvas: boolean
) => {
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const rafRef = useRef<number | null>(null)

  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return

    if (rafRef.current !== null) {
      cancelAnimationFrame(rafRef.current)
      rafRef.current = null
    }

    if (isRecording && analyserNode) {
      const dataArray = new Uint8Array(analyserNode.frequencyBinCount)
      const centerY = canvas.height / 2
      const draw = () => {
        analyserNode.getByteFrequencyData(dataArray)
        const ctx = canvas.getContext('2d')
        if (!ctx) return
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        ctx.fillStyle = WAVEFORM_COLOR
        for (let i = 0; i < BAR_COUNT; i++) {
          const amplitude = dataArray[i] / 255
          const barHeight = Math.max(2, amplitude * canvas.height * 0.9)
          ctx.fillRect(
            i * (BAR_WIDTH + BAR_GAP),
            centerY - barHeight / 2,
            BAR_WIDTH,
            barHeight
          )
        }
        rafRef.current = requestAnimationFrame(draw)
      }
      rafRef.current = requestAnimationFrame(draw)
    } else if (showCanvas) {
      drawFlatLine(canvas)
    }

    return () => {
      if (rafRef.current !== null) {
        cancelAnimationFrame(rafRef.current)
        rafRef.current = null
      }
    }
  }, [isRecording, analyserNode, showCanvas])

  return { canvasRef }
}
